module.exports = __webpack_public_path__ + "static/assets/bacc13779ca01580b89f39dd2118c22a.mp3";